import { render, staticRenderFns } from "./BusinessAcceptance.vue?vue&type=template&id=fbd3f518&scoped=true"
import script from "./BusinessAcceptance.vue?vue&type=script&lang=js"
export * from "./BusinessAcceptance.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./BusinessAcceptance.vue?vue&type=style&index=1&id=fbd3f518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd3f518",
  null
  
)

export default component.exports